import React from "react";
import Preview from "./Preview";
import ConnectiviteDivers from "../../../Common/ConnectiviteDivers";
import LanguageTable from "../../../Common/LanguageTable";
import { templateActions } from "../../../templateStore";

function Footer() {
    const [isReady, setIsReady] = React.useState(false);

    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                ["SiteWeb", "Divers", "Footer", "Description"],
                { AL: "", EN: "", ES: "", FR: "", IT: "" }
            );
            await templateActions.ensurePathExists(
                ["SiteWeb", "Divers", "Footer", "FollowUs"],
                { AL: "", EN: "", ES: "", FR: "", IT: "" }
            );

            setIsReady(true);
        };

        ensureAllPaths();
    }, []);
    if (!isReady) return null;

    return (
        <div
            className="d-grid__clz"
            style={{
                gridTemplateRows: "0.5fr 1.6fr",
                gap: "10px",
            }}
        >
            <Preview />
            <div
                style={{
                    overflow: "scroll",
                    height: "700px",
                    paddingBottom: "250px",
                    minHeight: "700px",
                }}
            >
                <LanguageTable
                    path={["SiteWeb", "Divers", "Footer"]}
                    fields={[
                        {
                            key: "Description",
                            label: "Description",
                            placeholder: "Enter the Description",
                        },
                    ]}
                    defaultTexts={{
                        Description: {
                            AL:
                                "Ne ofrojmë ushqime me cilësi të lartë dhe shërbimin më të mirë të dorëzimit, si dhe një treg ushqimor në të cilin mund të besoni verbërisht.",
                            EN:
                                "We offer high-quality food and the best delivery service, as well as a food market you can blindly trust.",
                            ES:
                                "Ofrecemos alimentos de alta calidad y el mejor servicio de entrega, así como un mercado de alimentos en el que puede confiar ciegamente.",
                            FR:
                                "Nous proposons des aliments de haute qualité et le meilleur service de livraison, ainsi qu'un marché alimentaire sur lequel vous pouvez compter aveuglément.",
                            IT:
                                "Offriamo alimenti di alta qualità e il miglior servizio di consegna, oltre a un mercato alimentare di cui potete fidarvi ciecamente.",
                        },
                    }}
                    sectionTitle="Message descriptif"
                />
                <ConnectiviteDivers
                    path={["template", "SiteWeb", "Divers", "SocialMedia"]}
                    languageTableConfig={{
                        path: ["SiteWeb", "Divers", "Footer"],
                        fields: [
                            {
                                key: "FollowUs",
                                label: "Description",
                                placeholder: "Enter the description",
                            },
                        ],
                        defaultTexts: {
                            FollowUs: {
                                AL: "Folgen Sie uns",
                                EN: "Follow us",
                                ES: "Síguenos",
                                FR: "Suivez-nous",
                                IT: "Seguici",
                            },
                        },
                        sectionTitle: "Message Social Media",
                    }}
                />
            </div>
        </div>
    );
}

export default Footer;
